import Axios from 'axios'
import Agilite from 'agilite'
import store from '../../../store'

const agilite = new Agilite({
  apiServerUrl: process.env.REACT_APP_AGILITE_API_URL,
  apiKey: process.env.REACT_APP_AGILITE_API_KEY
})

export const MedPraxSchemeSearch = async (searchQuery, page, pageLimit) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      let response = null

      try {
        response = await Axios.post(`${process.env.REACT_APP_NODE_RED_URL}/api/medprax/schemes`, {
          body: {
            filters: [
              {
                propertyName: 'name',
                operation: 'Contains',
                value: searchQuery ? searchQuery : ''
              }
            ],
            filterJoin: 'And',
            ascendingOrder: true,
            sortKey: 'Code'
          },
          pageLimit: 1000,
          page
        })
        resolve(response.data)
      } catch (e) {
        reject(e)
      }
    })()
  })
}

export const getBillingProfile = (filter = {}) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        const response = await agilite.Connectors.execute('billing_profiles', 'find_one', {
          filter: JSON.stringify(filter)
        })

        resolve(response.data)
      } catch (e) {
        reject(e)
      }
    })()
  })
}

export const createBillingProfile = (data) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        const response = await agilite.Connectors.execute('billing_profiles', 'create', {
          data: JSON.stringify({ entityRef: store.getState().core.entity._id, ...data })
        })

        resolve(response.data)
      } catch (e) {
        reject(e)
      }
    })()
  })
}

export const updateBillingProfile = (recordId, data) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        const response = await agilite.Connectors.execute('billing_profiles', 'update', {
          recordId,
          data: JSON.stringify(data)
        })

        resolve(response.data)
      } catch (e) {
        reject(e)
      }
    })()
  })
}

// export const DISCIPLINE_TYPES = [
//   { label: 'General Practice', value: 'General Practice', prefix: '01' },
//   { label: 'General Surgery', value: 'General Surgery', prefix: '02' },
//   { label: 'Allergy/Immunology', value: 'Allergy/Immunology', prefix: '03' },
//   { label: 'Otolaryngology', value: 'Otolaryngology', prefix: '04' },
//   { label: 'Anesthesiology', value: 'Anesthesiology', prefix: '05' },
//   { label: 'Cardiology', value: 'Cardiology', prefix: '06' },
//   { label: 'Dermatology', value: 'Dermatology', prefix: '07' },
//   { label: 'Family Practice', value: 'Family Practice', prefix: '08' },
//   { label: 'Interventional Pain Management', value: 'Interventional Pain Management', prefix: '09' },
//   { label: 'Gastroenterology', value: 'Gastroenterology', prefix: '10' },
//   { label: 'Internal Medicine', value: 'Internal Medicine', prefix: '11' },
//   { label: 'Osteopathic Manipulative Medicine', value: 'Osteopathic Manipulative Medicine', prefix: '12' },
//   { label: 'Neurology', value: 'Neurology', prefix: '13' },
//   { label: 'Neurosurgery', value: 'Neurosurgery', prefix: '14' },
//   { label: 'Speech Language Pathologist', value: 'Speech Language Pathologist', prefix: '15' },
//   { label: 'Obstetrics/Gynecology', value: 'Obstetrics/Gynecology', prefix: '16' },
//   { label: 'Hospice and Palliative Care', value: 'Hospice and Palliative Care', prefix: '17' },
//   { label: 'Ophthalmology', value: 'Ophthalmology', prefix: '18' },
//   { label: 'Oral Surgery (Dentist)', value: 'Oral Surgery (Dentist)', prefix: '19' },
//   { label: 'Orthopedic Surgery', value: 'Orthopedic Surgery', prefix: '20' },
//   { label: 'Cardiac Electrophysiology', value: 'Cardiac Electrophysiology', prefix: '21' },
//   { label: 'Pathology', value: 'Pathology', prefix: '22' },
//   { label: 'Sports Medicine', value: 'Sports Medicine', prefix: '23' },
//   { label: 'Plastic and Reconstructive Surgery', value: 'Plastic and Reconstructive Surgery', prefix: '24' },
//   { label: 'Physical Medicine and Rehabilitation', value: 'Physical Medicine and Rehabilitation', prefix: '25' },
//   { label: 'Psychiatry', value: 'Psychiatry', prefix: '26' },
//   { label: 'Geriatric Psychiatry', value: 'Geriatric Psychiatry', prefix: '27' },
//   { label: 'Colorectal Surgery', value: 'Colorectal Surgery', prefix: '28' },
//   { label: 'Pulmonary Disease', value: 'Pulmonary Disease', prefix: '29' },
//   { label: 'Diagnostic Radiology', value: 'Diagnostic Radiology', prefix: '30' },
//   { label: 'Thoracic Surgery', value: 'Thoracic Surgery', prefix: '33' },
//   { label: 'Urology', value: 'Urology', prefix: '34' },
//   { label: 'Chiropractic', value: 'Chiropractic', prefix: '35' },
//   { label: 'Nuclear Medicine', value: 'Nuclear Medicine', prefix: '36' },
//   { label: 'Pediatric Medicine', value: 'Pediatric Medicine', prefix: '37' },
//   { label: 'Geriatric Medicine', value: 'Geriatric Medicine', prefix: '38' },
//   { label: 'Nephrology', value: 'Nephrology', prefix: '39' },
//   { label: 'Hand Surgery', value: 'Hand Surgery', prefix: '40' },
//   { label: 'Optometry', value: 'Optometry', prefix: '41' },
//   { label: 'Infectious Disease', value: 'Infectious Disease', prefix: '44' },
//   { label: 'Endocrinology', value: 'Endocrinology', prefix: '46' },
//   { label: 'Podiatry', value: 'Podiatry', prefix: '48' },
//   { label: 'Rheumatology', value: 'Rheumatology', prefix: '66' },
//   {
//     label: 'Single or Multi‑specialty Group Practice',
//     value: 'Single or Multi‑specialty Group Practice',
//     prefix: '70'
//   },
//   { label: 'Pain Management', value: 'Pain Management', prefix: '72' },
//   { label: 'Peripheral Vascular Disease', value: 'Peripheral Vascular Disease', prefix: '76' },
//   { label: 'Vascular Surgery', value: 'Vascular Surgery', prefix: '77' },
//   { label: 'Cardiac Surgery', value: 'Cardiac Surgery', prefix: '78' },
//   { label: 'Addiction Medicine', value: 'Addiction Medicine', prefix: '79' },
//   { label: 'Critical Care (Intensivist)', value: 'Critical Care (Intensivist)', prefix: '81' },
//   { label: 'Hematology', value: 'Hematology', prefix: '82' },
//   { label: 'Hematology/Oncology', value: 'Hematology/Oncology', prefix: '83' },
//   { label: 'Preventive Medicine', value: 'Preventive Medicine', prefix: '84' },
//   { label: 'Maxillofacial Surgery', value: 'Maxillofacial Surgery', prefix: '85' },
//   { label: 'Neuropsychiatry', value: 'Neuropsychiatry', prefix: '86' },
//   { label: 'Medical Oncology', value: 'Medical Oncology', prefix: '90' },
//   { label: 'Surgical Oncology', value: 'Surgical Oncology', prefix: '91' },
//   { label: 'Radiation Oncology', value: 'Radiation Oncology', prefix: '92' },
//   { label: 'Emergency Medicine', value: 'Emergency Medicine', prefix: '93' },
//   { label: 'Interventional Radiology', value: 'Interventional Radiology', prefix: '94' },
//   { label: 'Gynecological/Oncology', value: 'Gynecological/Oncology', prefix: '98' },
//   { label: 'Unknown Physician Specialty', value: 'Unknown Physician Specialty', prefix: '99' },
//   { label: 'Sleep Medicine', value: 'Sleep Medicine', prefix: 'C0' },
//   { label: 'Interventional Cardiology', value: 'Interventional Cardiology', prefix: 'C3' },
//   { label: 'Dentist', value: 'Dentist', prefix: 'C5' },
//   { label: 'Hospitalist', value: 'Hospitalist', prefix: 'C6' },
//   {
//     label: 'Advanced Heart Failure & Transplant Cardiology',
//     value: 'Advanced Heart Failure & Transplant Cardiology',
//     prefix: 'C7'
//   },
//   { label: 'Medical Toxicology', value: 'Medical Toxicology', prefix: 'C8' },
//   {
//     label: 'Hematopoietic Cell Transplant & Cellular Therapy',
//     value: 'Hematopoietic Cell Transplant & Cellular Therapy',
//     prefix: 'C9'
//   },
//   { label: 'Medical Genetics & Genomics', value: 'Medical Genetics & Genomics', prefix: 'D3' },
//   { label: 'Undersea & Hyperbaric Medicine', value: 'Undersea & Hyperbaric Medicine', prefix: 'D4' },
//   { label: 'Micrographic Dermatologic Surgery', value: 'Micrographic Dermatologic Surgery', prefix: 'D7' },
//   { label: 'Adult Congenital Heart Disease', value: 'Adult Congenital Heart Disease', prefix: 'D8' },
//   { label: 'Marriage & Family Therapist', value: 'Marriage & Family Therapist', prefix: 'E1' },
//   { label: 'Mental Health Counselors', value: 'Mental Health Counselors', prefix: 'E2' },
//   { label: 'Dental Anesthesiology', value: 'Dental Anesthesiology', prefix: 'E3' },
//   { label: 'Dental Public Health', value: 'Dental Public Health', prefix: 'E4' },
//   { label: 'Endodontics', value: 'Endodontics', prefix: 'E5' },
//   { label: 'Oral & Maxillofacial Pathology', value: 'Oral & Maxillofacial Pathology', prefix: 'E6' },
//   { label: 'Oral & Maxillofacial Radiology', value: 'Oral & Maxillofacial Radiology', prefix: 'E7' },
//   { label: 'Oral Medicine', value: 'Oral Medicine', prefix: 'E9' },
//   { label: 'Orofacial Pain', value: 'Orofacial Pain', prefix: 'F1' },
//   { label: 'Orthodontics & Dentofacial Orthopedics', value: 'Orthodontics & Dentofacial Orthopedics', prefix: 'F2' },
//   { label: 'Pediatric Dentistry', value: 'Pediatric Dentistry', prefix: 'F3' },
//   { label: 'Periodontics', value: 'Periodontics', prefix: 'F4' },
//   { label: 'Prosthodontics', value: 'Prosthodontics', prefix: 'F5' },
//   { label: 'Epileptologists', value: 'Epileptologists', prefix: 'F6' }
// ]

export const DISCIPLINE_TYPES = [
  // MP - Medical Practitioners - General Practitioners
  { label: 'GP Standard', value: 'GP Standard', prefix: '014' },
  { label: 'GP Anaesthetist', value: 'GP Anaesthetist', prefix: '014A' },
  { label: 'Family Physician', value: 'Family Physician', prefix: '015' },

  // MP - Medical Practitioners - Specialists
  { label: 'Anaesthetics', value: 'Anaesthetics', prefix: '010' },
  { label: 'Dermatology', value: 'Dermatology', prefix: '012' },
  { label: 'Gynaecology', value: 'Gynaecology', prefix: '016' },
  { label: 'Pulmonology', value: 'Pulmonology', prefix: '017' },
  { label: 'Medicine (Specialist Physician)', value: 'Medicine (Specialist Physician)', prefix: '018' },
  { label: 'Gastroenterology', value: 'Gastroenterology', prefix: '019' },
  { label: 'Neurology', value: 'Neurology', prefix: '020' },
  { label: 'Cardiology', value: 'Cardiology', prefix: '021' },
  { label: 'Psychiatry', value: 'Psychiatry', prefix: '022' },
  { label: 'Medical Oncology', value: 'Medical Oncology', prefix: '023' },
  { label: 'Neurosurgery', value: 'Neurosurgery', prefix: '024' },
  { label: 'Nuclear Medicine', value: 'Nuclear Medicine', prefix: '025' },
  { label: 'Ophthalmology', value: 'Ophthalmology', prefix: '026' },
  { label: 'Clinical Haematology', value: 'Clinical Haematology', prefix: '027' },
  { label: 'Orthopaedics', value: 'Orthopaedics', prefix: '028' },
  { label: 'Otorhinolaryngology', value: 'Otorhinolaryngology', prefix: '030' },

  // DP - Dental Practitioners
  { label: 'General Dental Practice', value: 'General Dental Practice', prefix: '054' },
  { label: 'Maxillo-facial & Oral Surgery', value: 'Maxillo-facial & Oral Surgery', prefix: '062' },
  { label: 'Orthodontics', value: 'Orthodontics', prefix: '064' },
  { label: 'Oral Medicine and Periodontics', value: 'Oral Medicine and Periodontics', prefix: '092' },
  { label: 'Dental technicians', value: 'Dental technicians', prefix: '093' },
  { label: 'Prosthodontics', value: 'Prosthodontics', prefix: '094' },
  { label: 'Dental Therapy', value: 'Dental Therapy', prefix: '095' },

  // AP - Allied Practitioners
  { label: 'Chiropractors', value: 'Chiropractors', prefix: '004' },
  { label: 'Homoeopaths', value: 'Homoeopaths', prefix: '008' },
  { label: 'Radiography', value: 'Radiography', prefix: '039' },
  { label: 'Occupational Therapist', value: 'Occupational Therapist', prefix: '066' },
  { label: 'Podiatry', value: 'Podiatry', prefix: '068' },
  { label: 'Medical Scientist: Genetic', value: 'Medical Scientist: Genetic', prefix: '069' },
  { label: 'Physiotherapist', value: 'Physiotherapist', prefix: '072' },
  { label: 'Clinical Technologist', value: 'Clinical Technologist', prefix: '075' },
  { label: 'Medical Technology (037)', value: 'Medical Technology (037)', prefix: '076' },
  { label: 'Registered Counsellors', value: 'Registered Counsellors', prefix: '081' },
  { label: 'Speech Therapy / Audiology', value: 'Speech Therapy / Audiology', prefix: '082' },
  { label: 'Hearing Aid Acousticians', value: 'Hearing Aid Acousticians', prefix: '083' },
  { label: 'Dietician', value: 'Dietician', prefix: '084' },
  { label: 'Psychologist', value: 'Psychologist', prefix: '086' },
  { label: 'Registered Nurses', value: 'Registered Nurses', prefix: '088' },
  { label: 'Social Workers', value: 'Social Workers', prefix: '089' },

  // Additional Medical Practitioners
  { label: 'Rheumatology', value: 'Rheumatology', prefix: '031' },
  { label: 'Paediatric', value: 'Paediatric', prefix: '032' },
  { label: 'Paediatric Cardiology', value: 'Paediatric Cardiology', prefix: '033' },
  { label: 'Physical Medicine', value: 'Physical Medicine', prefix: '034' },
  { label: 'Plastic and Recon. Surgery', value: 'Plastic and Recon. Surgery', prefix: '036' },
  { label: 'Radiology', value: 'Radiology', prefix: '038' },
  { label: 'Radiation Oncology', value: 'Radiation Oncology', prefix: '040' },
  { label: 'Surgery', value: 'Surgery', prefix: '042' },
  { label: 'Cardiothoracic Surgery', value: 'Cardiothoracic Surgery', prefix: '044' },
  { label: 'Urology', value: 'Urology', prefix: '046' },
  { label: 'Clinical Pathology', value: 'Clinical Pathology', prefix: '052' },

  // Additional Allied Practitioners
  { label: 'Biokinetics', value: 'Biokinetics', prefix: '091' },
  { label: 'Naturopaths', value: 'Naturopaths', prefix: '101' },
  { label: 'Osteopathy', value: 'Osteopathy', prefix: '102' },
  { label: 'Phytotherapy', value: 'Phytotherapy', prefix: '103' },
  { label: 'Chinese Medicine', value: 'Chinese Medicine', prefix: '105' },
  { label: 'Tissue Transportation', value: 'Tissue Transportation', prefix: '003' },
  { label: 'Arts Therapy', value: 'Arts Therapy', prefix: '067' },
  { label: 'Orthoptists', value: 'Orthoptists', prefix: '074' },
  { label: 'Psychometry', value: 'Psychometry', prefix: '085' },
  { label: 'Ocularists', value: 'Ocularists', prefix: '090' },
  { label: 'Optometry', value: 'Optometry', prefix: '070' },
  { label: 'Orthotics', value: 'Orthotics', prefix: '087' }
]
